import { render, staticRenderFns } from "./DeleteConfigurationConfirm.vue?vue&type=template&id=a46b56e4"
import script from "./DeleteConfigurationConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteConfigurationConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports